import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71e60720"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-right" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_4 = { class: "name text-input col-span-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nome cantiere", -1))
const _hoisted_6 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_7 = { class: "customer text-input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customer" }, "Cliente (opzionale)", -1))
const _hoisted_9 = { class: "order-number text-input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "order-number" }, "Numero cantiere (opzionale)", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalDialog, { class: "add-new-working-site-modal-dialog" }, {
      h1: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
      ]),
      h2: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.subtitle), 1)
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_PrimaryButton, {
            class: "button bg-white text-gray-600 undo",
            onClick: _ctx.onClose
          }, {
            default: _withCtx(() => [
              _createTextVNode("Annulla")
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.isEditing)
            ? (_openBlock(), _createBlock(_component_PrimaryButton, {
                key: 0,
                class: "button bg-primary-900 text-white",
                onClick: _ctx.update
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Aggiorna")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : (_openBlock(), _createBlock(_component_PrimaryButton, {
                key: 1,
                class: "button bg-primary-900 text-white",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.create()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Crea")
                ]),
                _: 1
              }))
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["bg-white border-red-400", { border: _ctx.v$.step1.name.$error }]),
                id: "name",
                type: "text",
                placeholder: "Inserisci il nome del cantiere",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step1.name) = $event)),
                onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.v$.step1.name.$touch && _ctx.v$.step1.name.$touch(...args)))
              }, null, 34), [
                [_vModelText, _ctx.step1.name]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.step1.name.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "errors",
                  key: error.$uid
                }, [
                  (error.$validator == 'required')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_6, "È necessario inserire il nome del cantiere."))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                class: "bg-white border-red-400",
                id: "customer",
                type: "text",
                placeholder: "Inserisci il nome del cliente",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step1.customer) = $event))
              }, null, 512), [
                [_vModelText, _ctx.step1.customer]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                class: "bg-white border-red-400",
                id: "order-number",
                type: "text",
                placeholder: "Inserisci il numero del cantiere",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step1.orderNumber) = $event))
              }, null, 512), [
                [_vModelText, _ctx.step1.orderNumber]
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Salvataggio..."
        }))
      : _createCommentVNode("", true)
  ], 64))
}